"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customScrollBar = void 0;
var _styledComponents = require("styled-components");
var _colors = _interopRequireDefault(require("./colors"));
var customScrollBar = exports.customScrollBar = (0, _styledComponents.css)(["&::-webkit-scrollbar{background-color:", ";width:6px;height:6px;border-radius:3px;}&::-webkit-scrollbar-thumb{background-color:", ";border-radius:3px;&:active,&:hover{background-color:", ";}}"], _colors["default"].neutral200, _colors["default"].neutral600, _colors["default"].neutral700);
//# sourceMappingURL=scrollbar.js.map